import { Component, Input, OnInit, Optional, Self } from '@angular/core';
import { ControlValueAccessor, FormControl, NgControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { SelectOption } from 'src/app/@shared/interfaces/select-option.interface';

@Component({
    selector: 'mot-radio-button',
    templateUrl: './mot-radio-button.component.html',
    styleUrls: ['./mot-radio-button.component.scss'],
    standalone: false
})
export class MotRadioButtonComponent implements ControlValueAccessor, OnInit {
  @Input() options: Observable<SelectOption<any>[]>;
  @Input() value: string;
  @Input() class: string;
  @Input() radioClass: string;

  formControl: FormControl;

  constructor(@Optional() @Self() public ngControl: NgControl) {
    if (this.ngControl) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit() {
    if (this.ngControl) {
      this.formControl = this.ngControl.control as FormControl;
      if (this.value) {
        this.formControl.setValue(this.value);
      }
    }
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    if (!!this.formControl) {
      if (isDisabled) this.formControl.disable();
      else this.formControl.enable();
    }
  }
}
